module.exports = __webpack_public_path__ + "img/ic_close_orange.f48390d4.png";